//@flow
import { STORE_RATINGS, RESET_RATINGS } from '../actions/types';

export default (state: Object = {}, action) => {
  const { ratings, origin } = action;

  switch (action.type) {
    case STORE_RATINGS:
      return { ...state, ratings, origin };

    case RESET_RATINGS:
      return {};

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/ratingsReducer.js